import axios from 'axios'
import { instance } from '@cognitivecredit/ui-utils'

export const getFileDownloadUrls = async (docName: string) => {
  try {
    const req = await instance()
    const res = await req.get(`eng-watermark-removal/download-url/${docName}`)
    return res.data.data
  } catch (e) {
    console.error('Error getting file download URL', e)
  }
}

export const startWatermarkProcess = async (fileName: string) => {
  try {
    const req = await instance()
    const res = await req.post('eng-watermark-removal/start', {
      document_name: fileName,
    })
    return res.data.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const uploadDoc = async (url: string, file: File) => {
  const fileData = new FormData()
  fileData.append('upload_file', file)
  try {
    const res = await axios({
      method: 'PUT',
      url: url,
      data: fileData.get('upload_file'),
      headers: { 'content-type': 'application/pdf' },
    })
    return res
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getUploadUrl = async (fileName: string) => {
  try {
    const req = await instance()
    const { data } = await req.get(`eng-watermark-removal/upload-url/${fileName}`)
    return data.data.upload_url
  } catch (e) {
    return Promise.reject(e)
  }
}

export const saveAcceptedConfig = async (processIdentifier: string | null, configName: string | undefined) => {
  if (!processIdentifier || !configName) return
  try {
    const req = await instance()
    const res = await req.patch(`eng-watermark-removal/chosen-config/${processIdentifier}`, {
      config: configName,
    })
    return res.data.data
  } catch (e) {
    return Promise.reject(e)
  }
}
